<template>
    <x-app fill-height>
        <x-content fill-height>
            <transition-group
                :class="layout"
                :is="layout"
                class="fill-height"
                id="wrapper"
                mode="out-in"
                name="fade"
            >
                <router-view :info="info" :key="$route.fullPath" :notifications="notifications"/>
            </transition-group>
        </x-content>
    </x-app>
</template>

<script>
    export default {
        name: "App",
        props: ['info', 'notifications'],
        computed: {
            layout() {
                return (this.$route.meta.layout || 'default') + '-layout';
            },
        }
    }
</script>

<style lang="scss" scoped>
    fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }

</style>
